import { ILocation } from '../../../types/location';
import { EGeoSearchTypes } from '../constants';

export const getSearchType = (location: ILocation): EGeoSearchTypes => {
  switch (true) {
    case location.isRegion && location.hasMetro:
      return EGeoSearchTypes.REGION_WITH_UNDERGROUND;
    case location.isRegion:
      return EGeoSearchTypes.REGION;
    case location.hasDistricts && location.hasMetro:
      return EGeoSearchTypes.CITY_WITH_DISTRICTS_UNDERGROUND;
    case location.hasDistricts:
      return EGeoSearchTypes.CITY_WITH_DISTRICTS;
    default:
      return EGeoSearchTypes.CITY;
  }
};
